import {observer} from 'mobx-react';
import React from 'react';
import {ReactNodeGenerator} from '../../../../../../lib/helpers';
import {X9ContentStateStore} from '../../../common/X9ContentStateStore';
import {MQMatchingQuestion} from '../../models';
import {DropdownMatchingQuestionStore} from '../DropdownMatchingQuestionStore';
import {RightSideSelect} from '../RightSideSelect';

interface Props {
  id: number,
  question: MQMatchingQuestion,
  store: X9ContentStateStore,
  lessonType?: string
}

function* renderer(store: DropdownMatchingQuestionStore, lessonType?: string): ReactNodeGenerator {
  if (store.options.behavior !== 'dropdown')
    return;
  
  const leftSide = store.options.leftSide;
  const {dataPairs, dataPairStates, rightSideOptions} = store;
  const isExam = lessonType === 'Examination';

  for (let index = 0; index < dataPairs.length; index++) {
    const dataPair = dataPairs[index];
    const dataPairState = dataPairStates[index];

    const checked = dataPairState.matchedTo !== null && dataPairState.checked;
    const correct = dataPairState.matchedTo === index;
    let value = dataPairState.matchedTo === null
      ? null
      : dataPairState.matchedTo.toString(10);

    yield (
      <div className="row" key={'data-pair-' + index}>
        <div className="col-4 match-image-container">
          {leftSide === 'text' &&
          <div className="text-box">
            {dataPair.leftContent}
          </div>
          }
          {leftSide === 'image' &&
          <img src={dataPair.leftContent} alt="Image not found"  className="match-image" />
          }
        </div>

        <div className="col-4">
          <RightSideSelect options={rightSideOptions}
                           value={value}
                           onChange={(value) => store.select(index, value)}/>
        </div>
        {!isExam && (
          <div className="col-auto">
            {checked && correct &&
            <div className="alert alert-info">
              CORRECT!
            </div>
            }
            {checked && !correct &&
            <div className="alert alert-danger">
              INCORRECT!
            </div>
            }
          </div>
        )}
      </div>
    );
  }

  if (!isExam) {
    yield (
      <div className="row justify-content-end" key="check">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.check}>
            Check
          </button>
        </div>
      </div>
    );
  }
}

@observer
export class StudentDropdownMatchingQuestion extends React.Component<Props> {
  store: DropdownMatchingQuestionStore;

  constructor(props: Readonly<Props>) {
    super(props);
    this.store = new DropdownMatchingQuestionStore(props.id, props.question, props.store);
  }

  render() {
    return (
      <div className="row no-gutters">
        <div className="col">
          {Array.from(renderer(this.store, this.props.lessonType))}
        </div>
      </div>);
  }
}
